import { render, staticRenderFns } from "./SelectTransToMatch.vue?vue&type=template&id=7482d978&"
import script from "./SelectTransToMatch.vue?vue&type=script&lang=js&"
export * from "./SelectTransToMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports